export function trackUserSessionEvent(eventName, additionalProperties = {}) {
  if (window.FS && typeof window.FS === 'function') {
    try {
      window.FS('trackEvent', {
        name: eventName,
        properties: {
          timestamp: new Date().toISOString(),
          ...additionalProperties,
        },
      })
      console.info(`[FullStory] Event tracked: ${eventName}`)
    } catch (error) {
      console.error(`[FullStory] Failed to track event: ${eventName}`, error)
    }
  } else {
    console.warn('[FullStory] FS not initialized')
  }
}
